import React, {
  Suspense,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { Link } from "react-router-dom/";
import {
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import {
  changeArchivedFeature,
  DeleteArticle,
  getArticle,
  LikeCommentArticle,
} from "./Services/ArticleDiscussionBoardService";
import { TostMsg } from "../../../App";
import { Carousel } from "primereact/carousel";
import { LazyImage } from "../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding";
import moment from "moment";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
import { PostDate } from "../Dashboard/CommonComponents/PostDate";
import { InputSwitch } from "primereact/inputswitch";
import Commnent from "../../../Services/Comment/comment";
import { getEmployeeList } from "../EmployeeList/Service/employeeService";
import ComponentLoader from "../../../Shared/Sidebar/ComponentLoader";
import { Dialog } from "primereact/dialog";
import RecentArticle from "./RecentArticle";
const defaultImage = "/images/default-award-Image.svg";

function ArticleDetail() {
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  let userPermissions = JSON.parse(localStorage.getItem("Permissions") || "{}");
  const { articleId } = useParams();
   const { Archived } = useParams();
  const archivedValue = Archived ?? "0";
  const [articleList, setArticleList] = useState([]);
  const [articleImageList, setArticleImageList] = useState([]);
  const [articleLikeList, setArticleLikeList] = useState([]);
  const [articleCommentList, setArticleCommentList] = useState([]);
  const [loading, setLoading] = useState(false);
  const toster = useContext(TostMsg);
  const [articleComment, setarticleComment] = useState("");
  const [EditCommentId, setEditCommentId] = useState(0);
  const [IsArchived, setIsArchived] = useState(false);
  const [IsFeatured, setIsFeatured] = useState(false);
  const [moreArticleDes, setMoreArticleDes] = useState("");
  const [employee, setEmployee] = useState([]);
  const [loader, setLoader] = useState(false);
  const [userDeletePermission, setUserDeletePermission] = useState(false);
  const [userEditPermission, setUserEditPermission] = useState(false);
  const [deleteContent, setDeleteContent] = useState([]);
  const [articleDeleteId, setArticleDeleteId] = useState(0);
  const [articleIsMakeFeature, setArticleIsMakeFeature] = useState(false);
  const [articleIsMakeArchive, setArticleIsMakeArchive] = useState(false);
  let loaderExecute = "Execute";
  let history = useHistory();
  const responsiveOptions = [
    {
      breakpoint: "1400px",
      numVisible: 2,
      numScroll: 1,
    },
    {
      breakpoint: "1199px",
      numVisible: 3,
      numScroll: 1,
    },
    {
      breakpoint: "767px",
      numVisible: 2,
      numScroll: 1,
    },
    {
      breakpoint: "575px",
      numVisible: 1,
      numScroll: 1,
    },
  ];

  useEffect(() => {
    GetMasterSystemAlertList();
    fetchEmployeeData();
    permissionArticleAdd();
  }, []);

  useEffect(() => {
    if (articleId) {
      GetArticleList(loaderExecute);
    }
  }, [articleId]);

  const permissionArticleAdd = () => {
    userPermissions.map((UserPermission) => {
      if (UserPermission.PermissionName == "Delete Article") {
        setUserDeletePermission(true);
      } else if (UserPermission.PermissionName == "Edit Article") {
        setUserEditPermission(true);
      } else if (UserPermission.PermissionName == "MarkAsFeature") {
        setArticleIsMakeFeature(true);
      } else if (UserPermission.PermissionName == "MarkAsArchieve") {
        setArticleIsMakeArchive(true);
      }
    });
  };

  async function GetArticleList(loder) {
    if (loder == "Not_Excute") {
      setLoading(false);
    } else {
      setLoading(true);
    }
    const params = {
      LoggedInUserId: userDetails?.EmpId,
      OrgId: userDetails?.OrgId,
      articleByGUID: articleId,
      articleId: 0,
      Search: "",
      articleById: 0,
      IsFeatured: 0,
      IsArchived: Number(archivedValue),
      PageNumber: 1,
      PageSize: 10,
    };
    try {
      const response = await getArticle(params);
      setLoading(false);
      const articleData = response.Data?.orgArticles || [];
      if (articleData.length > 0) {
        const imageData = response.Data?.orgArticles?.[0]?.ArticleMedia;
        let articleLikeList =
          response.Data?.orgArticles?.[0]?.organizationArticleLikeResponses?.filter(
            (articleLike) => articleLike.EmpId === userDetails.EmpId
          );
        let articleCommentList =
          response.Data?.orgArticles?.[0]?.organizationArticleCommentResponses;
        setArticleImageList(imageData);
        setArticleLikeList(articleLikeList);
        setArticleCommentList(articleCommentList);
        setArticleList(articleData[0]);
        setIsArchived(articleData[0]?.IsArchived);
        setIsFeatured(articleData[0]?.IsFeatured);
      }
    } catch (error) {
      setLoading(false);
      toster.current.error(ERROR_LIST.DefaultError);
    }
  }

  const articleTemplate = (article) => {
    return (
      <img
        src={article?.Media || defaultImage}
        className="bgimages"
        onError={handleImageError}
      />
    );
  };

  async function updateLikeStatus(lst, type) {
    let MyLikeId = articleLikeList[0]?.Id;
    let setIsActive = true;
    if (type == articleLikeList[0]?.Reaction) {
      setIsActive = false;
    }
    const params = {
      Id: MyLikeId,
      ArticleId: articleList?.Id,
      ArticleReactionTypeId: 101,
      Reaction: type,
      IsActive: setIsActive,
    };
    try {
      await LikeCommentArticle(params);
      loaderExecute = "Not_Excute";
      GetArticleList(loaderExecute);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toster.current.error(ERROR_LIST.DefaultError);
    }
  }

  async function submitComment(CommentData, nan, CommentText, type) {
    setLoader(true);
    const params = {
      Id: CommentData?.Id ?? 0,
      OrgId: userDetails?.OrgId,
      EmpId: userDetails?.EmpId,
      ArticleId: articleList?.Id,
      ArticleReactionTypeId: 102,
      Reaction: CommentText,
    };
    try {
      const response = await LikeCommentArticle(params);
      GetMasterSystemAlertList("Added_successfully", 0);
      loaderExecute = "Not_Excute";
      GetArticleList(loaderExecute);
      setarticleComment("");
      setEditCommentId(0);
      setLoader(false);
    } catch (error) {
      // toster.current.error(ERROR_LIST.DefaultError);
      setLoader(false);
    }
  }

  const EditComment = useCallback(
    (event) => {
      setEditCommentId(1);
      setarticleComment(event);
      handleScroll();
    },
    [articleComment]
  );

  function handleScroll() {
    window.scroll({
      top: document.body.offsetHeight,
      left: 0,
      behavior: "smooth",
    });
  }

  const DeleteComment = async (el) => {
    setLoading(true);
    let body = {
      Id: el?.Id,
      ArticleId: articleList?.Id,
      ArticleReactionTypeId: 102,
      Reaction: el.Reaction,
      IsActive: false,
    };
    try {
      await LikeCommentArticle(body);
      GetArticleList(loaderExecute);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage;
  }, []);

  const EmojiReaction = (reaction) => {
    if (reaction != undefined) {
      let newReaction = reaction?.map((el) => el?.Reaction);
      var replaceSameEmoji = newReaction?.toString();
      const replacedEmoji = Array.from(
        new Set(replaceSameEmoji?.split(","))
      )?.join(",");
      return (
        <div className="emojis-group">
          {replacedEmoji.includes("Love") ? (
            <img
              src="/images/main-body/post/emojis/1.gif"
              width="100%"
              style={{ opacity: "1", borderRadius: "100%", marginLeft: "0px" }}
            />
          ) : (
            ""
          )}
          {replacedEmoji.includes("Like") ? (
            <img
              src="/images/main-body/post/emojis/0.gif"
              width="100%"
              style={{ opacity: "1", borderRadius: "100%", marginLeft: "0px" }}
            />
          ) : (
            ""
          )}
          {replacedEmoji.includes("Laugh") ? (
            <img
              src="/images/main-body/post/emojis/2.gif"
              width="100%"
              style={{ opacity: "1", borderRadius: "100%", marginLeft: "0px" }}
            />
          ) : (
            ""
          )}
          {replacedEmoji.includes("Surprised") ? (
            <img
              src="/images/main-body/post/emojis/3.gif"
              width="100%"
              style={{ opacity: "1", borderRadius: "100%", marginLeft: "0px" }}
            />
          ) : (
            ""
          )}
          {replacedEmoji.includes("Sad") ? (
            <img
              src="/images/main-body/post/emojis/5.gif"
              width="100%"
              style={{ opacity: "1", borderRadius: "100%", marginLeft: "0px" }}
            />
          ) : (
            ""
          )}
        </div>
      );
    } else {
      <div>
        {" "}
        <i className="fa fa-heart-o heart-fa" />
        💗
      </div>;
    }
  };

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == "Articl_Details_show_more") {
        setMoreArticleDes(msg?.Desc);
      } else if (msg?.Name == message) {
        setDeleteContent(msg?.Desc);
      }
    });
  }, []);

  const handleInputChangeIsArchived = async (e) => {
    setIsArchived(e.value);
    const params = {
      EmpId: userDetails?.EmpId,
      ArticleId: articleList?.Id,
      isFeature: IsFeatured,
      isArchive: e.value,
    };
    setLoading(true);
    try {
      let response = await changeArchivedFeature(params);
      GetArticleList(loaderExecute);
      toster.current.success(response?.Message);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const handleInputChangeIsFeatured = async (e) => {
    setIsFeatured(e.value);
    const params = {
      EmpId: userDetails?.EmpId,
      ArticleId: articleList?.Id,
      isFeature: e.value,
      isArchive: IsArchived,
    };
    setLoading(true);
    try {
      let response = await changeArchivedFeature(params);
      GetArticleList(loaderExecute);
      toster.current.success(response?.Message);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  async function fetchEmployeeData() {
    var params = {
      OrganisationId: userDetails?.OrgId,
      LoggedInEmployeeId: userDetails?.EmpId,
      IsDirectReportOrHierarchy: 0,
      SearchText: "",
      FollowersOnly: 0,
      FollowingsOnly: 0,
      IsExEmployeesAlso: 0,
      pageNumber: 1,
      pageSize: 5000000,
      EmployeeId: 0,
      IsSuggestedOnly: 0,
    };
    try {
      let employeesList = await getEmployeeList(params);
      setEmployee(employeesList.Data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }

  async function deleteArticleDetails() {
    if (articleDeleteId) {
      let body = {
        Id: articleDeleteId,
        EmpId: userDetails?.EmpId,
      };
      try {
        setLoading(true);
        let articleList = await DeleteArticle(body);
        if (articleList) {
          setLoading(false);
          document.getElementById("delete-ed").click();
          GetMasterSystemAlertList("Article_Deleted", 0);
          history.push(`/Articles`);
        }
      } catch (error) {
        toster.current.error(ERROR_LIST.DefaultError);
        setLoading(false);
      }
    }
  }

  const [likeListData, setLikeListData] = useState([]);
  const [visibleLike, setVisibleLike] = useState(false);
  const [likeListFilterData, setLikeListFilterData] = useState([]);

  async function FeedLikeListData(event) {
    setLikeListData(event?.organizationArticleLikeResponses);
    setLikeListFilterData(event?.organizationArticleLikeResponses);
    setVisibleLike(true);
  }

  function FeedLikeChange(likeData, type) {
    if (type == "All") {
      setLikeListData(likeData);
    } else if (type == "Like") {
      let likes = likeData?.filter((data) => data.Reaction == "Like");
      setLikeListData(likes);
    } else if (type == "Love") {
      let likes = likeData?.filter((data) => data.Reaction == "Love");
      setLikeListData(likes);
    } else if (type == "Laugh") {
      let likes = likeData?.filter((data) => data.Reaction == "Laugh");
      setLikeListData(likes);
    } else if (type == "Surprised") {
      let likes = likeData?.filter((data) => data.Reaction == "Surprised");
      setLikeListData(likes);
    } else if (type == "Sad") {
      let likes = likeData?.filter((data) => data.Reaction == "Sad");
      setLikeListData(likes);
    }
  }

  function LikeListDataUpdate() {
    setLikeListData([]);
  }

  const MyEmojiReaction = (reaction) => {
    var replaceSameEmoji = reaction?.toString();
    const replacedEmoji = Array.from(
      new Set(replaceSameEmoji?.split(","))
    )?.join(",");
    return (
      <div className="emojis-group">
        {replacedEmoji.includes("Love") ? (
          <img src="/images/main-body/post/emojis/1.gif" alt="" />
        ) : (
          ""
        )}
        {replacedEmoji.includes("Like") ? (
          <img src="/images/main-body/post/emojis/0.gif" alt="" />
        ) : (
          ""
        )}
        {replacedEmoji.includes("Laugh") ? (
          <img src="/images/main-body/post/emojis/2.gif" alt="" />
        ) : (
          ""
        )}
        {replacedEmoji.includes("Surprised") ? (
          <img src="/images/main-body/post/emojis/3.gif" alt="" />
        ) : (
          ""
        )}
        {replacedEmoji.includes("Sad") ? (
          <img src="/images/main-body/post/emojis/5.gif" alt="" />
        ) : (
          ""
        )}
      </div>
    );
  };

  return (
    <div>
      <div className="container-fluid   position-relation">
        <div className="row g-3">
          <div className="form-head d-flex flex-wrap align-items-center d-none">
            <div className="me-auto">
              <h2 className="font-w600 mb-0">Article Detail</h2>
              <p className="text-light">
                Recognizing Your Outstanding Achievements.!
              </p>
            </div>
            <div className="rightside-tabs">
              <div className="">
                <a href="/AddAward">
                  <div className="org-add">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="currentColor"
                      className="bi bi-plus"
                      viewBox="0 0 16 16"
                      data-bs-toggle="modal"
                      data-bs-target="#article-popup"
                    >
                      <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"></path>
                    </svg>
                  </div>
                </a>
              </div>
            </div>
          </div>
          <div>
            <div className="row g-4">
              <div style={{ textAlign: "end" }}>
                <div className="col-sm-12">
                  <div className="actionbutton-tickets artical">
                    {articleIsMakeArchive && (
                      <div className="select-futurepost-article">
                        <label>
                          {IsArchived
                            ? "Mark as Unarchived"
                            : "Mark as Archived"}
                        </label>
                        <div className="ml-auto d-flex">
                          <InputSwitch
                            checked={IsArchived}
                            onChange={(e) => handleInputChangeIsArchived(e)}
                          />
                        </div>
                      </div>
                    )}
                    {articleIsMakeFeature && (
                      <div className="select-futurepost-article">
                        <label>
                          {IsFeatured
                            ? "Mark as UnFeatured"
                            : "Mark as Featured"}
                        </label>
                        <div className="ml-auto d-flex">
                          <InputSwitch
                            checked={IsFeatured}
                            onChange={(e) => handleInputChangeIsFeatured(e)}
                          />
                        </div>
                      </div>
                    )}

                    {userEditPermission && (
                      <Link
                        to={`/Artical/Edit/${articleList?.GUID}/${archivedValue}`}
                        title="Edit"
                      >
                        <button className="article-editbtn">Edit</button>
                      </Link>
                    )}
                    {userDeletePermission && (
                      <button
                        type="button"
                        className="article-deletebtn"
                        data-bs-toggle="modal"
                        data-bs-target="#delete-ed"
                        title="Delete"
                        data-bs-original-title="delete"
                        aria-label="delete"
                        onClick={() => {
                          setArticleDeleteId(articleList?.Id);
                          GetMasterSystemAlertList(
                            "Article_Delete_Confirmation"
                          );
                        }}
                      >
                        Delete
                      </button>
                    )}
                    <Link to="/Articles">
                      <button className="article-backbtn" title="Back">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="currentColor"
                          className="bi bi-arrow-left-short"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fillRule="evenodd"
                            d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5"
                          />
                        </svg>{" "}
                        Back
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-xl-8">
                <div className="row card-radius">
                  <div className="col-xl-12">
                    <div className="card">
                      <div className="card-body">
                        <div className="article-title">
                          {articleImageList?.length !=0 ? (
                            <Carousel
                              value={articleImageList}
                              numVisible={1}
                              numScroll={1}
                              responsiveOptions={responsiveOptions}
                              itemTemplate={articleTemplate}
                            />
                          ) : (
                            <img
                              src={defaultImage}
                              className="bgimages"
                              onError={handleImageError}
                            />
                          )}
                          <p className="article-category"></p>
                          <h3 className="block-heading mt-2">
                            {articleList?.Title}
                          </h3>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: articleList?.Summary,
                            }}
                          />
                          <div className="d-flex align-items-center">
                            <div
                              className="writtenby d-flex align-items-center"
                              style={{ marginTop: "14px" }}
                            >
                              <div className="image">
                                <LazyImage
                                  src={articleList?.ArticleByProfileImage}
                                  width="100%"
                                />
                              </div>
                              <p>
                                <span>Written by</span>
                                {articleList.ArticleByName}
                                <span className="inerdate">
                                  <img src="/images/policy/date.svg" />
                                  On{" "}
                                  {moment(articleList?.ModifiedDate).format(
                                    "MMM DD YYYY"
                                  )}
                                </span>
                              </p>
                            </div>
                            <div className="likes d-flex align-items-center ml-auto justify-content-end">
                              <div className="social-count">
                                <div className="like-wrapper">
                                  <div className="like-button">
                                    {articleList?.IsLikedByMe == 0 ? (
                                      <div className="emojis-group emojis-byuser">
                                        <a className="like-button">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            fill="currentColor"
                                            class="bi bi-hand-thumbs-up"
                                            viewBox="0 0 16 16"
                                          >
                                            <path d="M8.864.046C7.908-.193 7.02.53 6.956 1.466c-.072 1.051-.23 2.016-.428 2.59-.125.36-.479 1.013-1.04 1.639-.557.623-1.282 1.178-2.131 1.41C2.685 7.288 2 7.87 2 8.72v4.001c0 .845.682 1.464 1.448 1.545 1.07.114 1.564.415 2.068.723l.048.03c.272.165.578.348.97.484.397.136.861.217 1.466.217h3.5c.937 0 1.599-.477 1.934-1.064a1.86 1.86 0 0 0 .254-.912c0-.152-.023-.312-.077-.464.201-.263.38-.578.488-.901.11-.33.172-.762.004-1.149.069-.13.12-.269.159-.403.077-.27.113-.568.113-.857 0-.288-.036-.585-.113-.856a2 2 0 0 0-.138-.362 1.9 1.9 0 0 0 .234-1.734c-.206-.592-.682-1.1-1.2-1.272-.847-.282-1.803-.276-2.516-.211a10 10 0 0 0-.443.05 9.4 9.4 0 0 0-.062-4.509A1.38 1.38 0 0 0 9.125.111zM11.5 14.721H8c-.51 0-.863-.069-1.14-.164-.281-.097-.506-.228-.776-.393l-.04-.024c-.555-.339-1.198-.731-2.49-.868-.333-.036-.554-.29-.554-.55V8.72c0-.254.226-.543.62-.65 1.095-.3 1.977-.996 2.614-1.708.635-.71 1.064-1.475 1.238-1.978.243-.7.407-1.768.482-2.85.025-.362.36-.594.667-.518l.262.066c.16.04.258.143.288.255a8.34 8.34 0 0 1-.145 4.725.5.5 0 0 0 .595.644l.003-.001.014-.003.058-.014a9 9 0 0 1 1.036-.157c.663-.06 1.457-.054 2.11.164.175.058.45.3.57.65.107.308.087.67-.266 1.022l-.353.353.353.354c.043.043.105.141.154.315.048.167.075.37.075.581 0 .212-.027.414-.075.582-.05.174-.111.272-.154.315l-.353.353.353.354c.047.047.109.177.005.488a2.2 2.2 0 0 1-.505.805l-.353.353.353.354c.006.005.041.05.041.17a.9.9 0 0 1-.121.416c-.165.288-.503.56-1.066.56z" />
                                          </svg>
                                          <span className="like-overlay"></span>
                                        </a>
                                        <div
                                          className="upload-like"
                                          style={{
                                            right: "0rem",
                                            bottom: "29px",
                                          }}
                                        >
                                          <ul className="emoji-ul">
                                            <li>
                                              <img
                                                src="/images/main-body/post/emojis/0.gif"
                                                alt=""
                                                onClick={() =>
                                                  updateLikeStatus(
                                                    articleList,
                                                    "Like"
                                                  )
                                                }
                                              />
                                            </li>
                                            <li>
                                              <img
                                                src="/images/main-body/post/emojis/1.gif"
                                                alt=""
                                                onClick={() =>
                                                  updateLikeStatus(
                                                    articleList,
                                                    "Love"
                                                  )
                                                }
                                              />
                                            </li>
                                            <li>
                                              <img
                                                src="/images/main-body/post/emojis/2.gif"
                                                alt=""
                                                onClick={() =>
                                                  updateLikeStatus(
                                                    articleList,
                                                    "Laugh"
                                                  )
                                                }
                                              />
                                            </li>
                                            <li>
                                              <img
                                                src="/images/main-body/post/emojis/3.gif"
                                                alt=""
                                                onClick={() =>
                                                  updateLikeStatus(
                                                    articleList,
                                                    "Surprised"
                                                  )
                                                }
                                              />
                                            </li>
                                            <li>
                                              <img
                                                src="/images/main-body/post/emojis/5.gif"
                                                alt=""
                                                onClick={() =>
                                                  updateLikeStatus(
                                                    articleList,
                                                    "Sad"
                                                  )
                                                }
                                              />
                                            </li>
                                          </ul>
                                        </div>
                                      </div>
                                    ) : (
                                      <>
                                        <div className="emojis-group emojis-byuser">
                                          {EmojiReaction(articleLikeList)}

                                          <div
                                            className="upload-like"
                                            style={{
                                              right: "0rem",
                                              bottom: "29px",
                                            }}
                                          >
                                            <ul className="emoji-ul">
                                              <li>
                                                <img
                                                  src="/images/main-body/post/emojis/0.gif"
                                                  alt=""
                                                  onClick={() =>
                                                    updateLikeStatus(
                                                      articleList,
                                                      "Like"
                                                    )
                                                  }
                                                />
                                              </li>
                                              <li>
                                                <img
                                                  src="/images/main-body/post/emojis/1.gif"
                                                  alt=""
                                                  onClick={() =>
                                                    updateLikeStatus(
                                                      articleList,
                                                      "Love"
                                                    )
                                                  }
                                                />
                                              </li>
                                              <li>
                                                <img
                                                  src="/images/main-body/post/emojis/2.gif"
                                                  alt=""
                                                  onClick={() =>
                                                    updateLikeStatus(
                                                      articleList,
                                                      "Laugh"
                                                    )
                                                  }
                                                />
                                              </li>
                                              <li>
                                                <img
                                                  src="/images/main-body/post/emojis/3.gif"
                                                  alt=""
                                                  onClick={() =>
                                                    updateLikeStatus(
                                                      articleList,
                                                      "Surprised"
                                                    )
                                                  }
                                                />
                                              </li>
                                              <li>
                                                <img
                                                  src="/images/main-body/post/emojis/5.gif"
                                                  alt=""
                                                  onClick={() =>
                                                    updateLikeStatus(
                                                      articleList,
                                                      "Sad"
                                                    )
                                                  }
                                                />
                                              </li>
                                            </ul>
                                          </div>
                                        </div>
                                      </>
                                    )}

                                    {articleList?.IsLikedByMe === 0 &&
                                      articleList?.ArticleLikecount === 0 && (
                                        <span> </span>
                                      )}
                                    {articleList?.IsLikedByMe === 0 &&
                                      articleList?.ArticleLikecount >= 1 && (
                                        <span
                                          onClick={() =>
                                            FeedLikeListData(articleList)
                                          }
                                        >
                                          <span style={{ color: "#671cc9" }}>
                                            <strong>
                                              {articleList.ArticleLikecount}{" "}
                                              {articleList?.ArticleLikecount >=
                                              1
                                                ? "Other"
                                                : "Others"}
                                            </strong>
                                          </span>
                                          &nbsp;like this
                                        </span>
                                      )}
                                    {articleList?.IsLikedByMe === 1 &&
                                      articleList?.ArticleLikecount == 1 && (
                                        <span
                                          onClick={() =>
                                            FeedLikeListData(articleList)
                                          }
                                        >
                                          You liked this
                                        </span>
                                      )}
                                    {articleList?.IsLikedByMe === 1 &&
                                      articleList?.ArticleLikecount >= 2 && (
                                        <span
                                          onClick={() =>
                                            FeedLikeListData(articleList)
                                          }
                                        >
                                          You and&nbsp;
                                          <span style={{ color: "#671cc9" }}>
                                            <strong>
                                              {articleList.ArticleLikecount - 1}{" "}
                                              {articleList?.ArticleLikecount ==
                                              2
                                                ? "other"
                                                : "others"}
                                            </strong>
                                          </span>
                                          &nbsp;like this
                                        </span>
                                      )}
                                    <span className="like-overlay"></span>
                                  </div>
                                </div>
                              </div>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-chat-right-dots-fill"
                                viewBox="0 0 16 16"
                                style={{
                                  color: "#0c357d",
                                  marginLeft: ".2rem",
                                }}
                              >
                                <path d="M16 2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h9.586a1 1 0 0 1 .707.293l2.853 2.853a.5.5 0 0 0 .854-.353zM5 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0m4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 1a1 1 0 1 1 0-2 1 1 0 0 1 0 2" />
                              </svg>
                              {articleList?.ArticleCommentCount > 0 && (
                                <span>
                                  {articleList?.ArticleCommentCount}{" "}
                                  {articleList?.ArticleCommentCount == 1
                                    ? "Comment"
                                    : "Comments"}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-12">
                  <div className="card">
                    <div className="card-body ">
                      <div className="more-jobdetail">
                        <strong className="">Comments</strong>
                        <div className="article-commentsec">
                          <Commnent
                            sendCommentData={submitComment}
                            reciveCommentData={articleComment}
                            employeesList={employee}
                            commentType={EditCommentId}
                            loader={loader}
                          />
                        </div>
                        {articleCommentList.map((comment) => {
                          return (
                            <div className="articlescomment d-flex">
                              <LazyImage
                                src={comment?.ReactionGivenByProfileImage}
                                data-user-popover="1"
                                alt=""
                              />
                              <div className="message-text">
                                <a href="">{comment?.ReactionGivenByName}</a>
                                <p>{comment?.Reaction}</p>
                                <div className="articlecomment-date">
                                  <PostDate
                                    LastCommentDate={comment?.CreatedDate}
                                  />{" "}
                                </div>
                              </div>
                              {comment?.IsMyReaction == 1 && (
                                <div className="commentarticle">
                                  <a
                                    onClick={() => {
                                      EditComment(comment);
                                    }}
                                  >
                                    <img
                                      src="/images/tickets/edit-ico.svg"
                                      className="editdivinfo"
                                    />
                                  </a>
                                  <a onClick={() => DeleteComment(comment)}>
                                    {" "}
                                    <img
                                      src="/images/tickets/delete.svg"
                                      className="editdivinfo"
                                    />
                                  </a>
                                </div>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-4">
                <RecentArticle />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal fade" id="delete-ed">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content delete-holiday">
            <div className="modal-header">
              <img
                src="/images/org-img/leave/popup-backimg.png"
                className="backimg"
              />
              <div className="img">
                <img src="/images/org-img/leave/trash.png" />
              </div>
            </div>
            <div className="modal-body text-center">
              <strong className="modal-title">Are you sure?</strong>
              <p>{deleteContent}</p>
            </div>
            <div className="modal-footer m-auto">
              <button
                type="button"
                className="cancelbtn-click"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>

              <button
                type="button"
                className="deletebtn-click"
                data-bs-dismiss="modal"
                onClick={() => deleteArticleDetails()}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
      <Dialog
        visible={visibleLike}
        style={{ width: "20vw" }}
        onHide={() => {
          if (!visibleLike) return;
          setVisibleLike(false);
          LikeListDataUpdate();
        }}
      >
        <div className="total-likesmodal">
          <div className="modal-header p-0 px-2">
            <strong className="modal-title">
              <h5 className="modal-title">People who reacted</h5>
            </strong>
          </div>
          <div className="modal-body text-center">
            <div className="likeItemArrange">
              <div className="likediv">
                <button
                  type="button"
                  data-bs-dismiss="model"
                  onClick={() => FeedLikeChange(likeListFilterData, "All")}
                >
                  All
                </button>
              </div>

              {likeListFilterData?.filter((item) => item.Reaction === "Like")
                .length > 0 && (
                <div className="likediv">
                  <button className="" type="button">
                    <img
                      src="/images/main-body/post/emojis/0.gif"
                      onClick={() => FeedLikeChange(likeListFilterData, "Like")}
                    />
                    {
                      likeListFilterData?.filter(
                        (item) => item.Reaction === "Like"
                      ).length
                    }
                  </button>
                </div>
              )}

              {likeListFilterData?.filter((item) => item.Reaction === "Love")
                .length > 0 && (
                <div className="likediv">
                  <button className="" type="button">
                    <img
                      src="/images/main-body/post/emojis/1.gif"
                      onClick={() => FeedLikeChange(likeListFilterData, "Love")}
                    />
                    {
                      likeListFilterData?.filter(
                        (item) => item.Reaction === "Love"
                      ).length
                    }
                  </button>
                </div>
              )}
              {likeListFilterData?.filter((item) => item.Reaction === "Laugh")
                .length > 0 && (
                <div className="likediv">
                  <button className="" type="button">
                    <img
                      src="/images/main-body/post/emojis/2.gif"
                      onClick={() =>
                        FeedLikeChange(likeListFilterData, "Laugh")
                      }
                    />
                    {
                      likeListFilterData?.filter(
                        (item) => item.Reaction === "Laugh"
                      ).length
                    }
                  </button>
                </div>
              )}
              {likeListFilterData?.filter(
                (item) => item.Reaction === "Surprised"
              ).length > 0 && (
                <div className="likediv">
                  <button className="" type="button">
                    <img
                      src="/images/main-body/post/emojis/3.gif"
                      onClick={() =>
                        FeedLikeChange(likeListFilterData, "Surprised")
                      }
                    />
                    {
                      likeListFilterData?.filter(
                        (item) => item.Reaction === "Surprised"
                      ).length
                    }
                  </button>
                </div>
              )}

              {likeListFilterData?.filter((item) => item.Reaction === "Sad")
                .length > 0 && (
                <div className="likediv">
                  <button className="" type="button">
                    <img
                      src="/images/main-body/post/emojis/5.gif"
                      onClick={() => FeedLikeChange(likeListFilterData, "Sad")}
                    />
                    {
                      likeListFilterData?.filter(
                        (item) => item.Reaction === "Sad"
                      ).length
                    }
                  </button>
                </div>
              )}
            </div>
            <div className="friend-list p-2">
              {likeListData?.map((reaction) => (
                <div className="friend-item">
                  <div className="friend-info">
                    <img
                      src={
                        reaction?.ReactionGivenByProfileImage || defaultImage
                      }
                      alt="Profile"
                      onError={handleImageError}
                    />
                    <span>{reaction?.ReactionGivenByName}</span>
                    {MyEmojiReaction(reaction?.Reaction)}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Dialog>
      {loading ? (
        <Suspense>
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
    </div>
  );
}

export default ArticleDetail;
